import React, { useState, useEffect } from "react";
import "./MeetingsTable.css";
import DataTable from "../../components/common/DataTable/DataTable";
import { useGetMeetingsByTypeQuery } from "./meetingSlice";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";

import { selectCurrentUser } from "../auth/authSlice";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

const CustomerStatusCell = ({ customerStatus }) =>
  customerStatus ? (
    <input type="checkbox" className="green-checkbox" checked disabled />
  ) : (
    <input type="checkbox" className="green-bordered" disabled />
  );

const meetingsHeading = [
  { name: "Date", selector: (row) => row.meetingDate, sortable: true },
  { name: "Initials", selector: (row) => row.initials, sortable: true },
  { name: "Customer.", selector: (row) => row.customerName, sortable: true },
  {
    name: "New Customer",
    selector: (row) => row.customerStatus,
    sortable: true,
    cell: (row) => <CustomerStatusCell customerStatus={row.customerStatus} />,
  },
  {
    name: "Representative",
    selector: (row) => row.representativeName,
    sortable: true,
  },
];

const MeetingsTable = ({ handleFilter, handleEmployeeSelection }) => {
  const user = useSelector(selectCurrentUser);

  const [userId, setUserId] = useState(user.userID);

  function getUserId(value) {
    setUserId(value);
  }
  const [type, setType] = useState("today");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  function handleChildClick(value, startDate, endDate) {
    setType(value);
    setStartDate(startDate);
    setEndDate(endDate);
    handleFilter(value, startDate, endDate);
  }

  //const {data: meetings, isLoading, isFetching, isSuccess, isError, error} = useGetMeetingsByUserIdQuery(userId);
  const {
    data: meetings,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetMeetingsByTypeQuery({
    type: type,
    startDate: startDate,
    endDate: endDate,
  });

  const [meetingsData, setMeetingsData] = useState([]);


  useEffect(() => {
    if (meetings) {
      const data = meetings.ids.map((id) => {
        return meetings.entities[id];
      });
      setMeetingsData(data);
    }
    if (error) {
      toast.error(
        `Fetching meetings failed: ${
          error?.data?.Message || error?.data?.title
        } `
      );
    }
  }, [meetings, type, error]);

  return (
    <div>
      {isLoading && <LoadingSpinner />}
      <DataTable
        type={"meetings"}
        allData={meetingsData}
        tableHeading={meetingsHeading}
        itemsPerPage={meetingsData.length}
        newOption={2}
        getUserId={getUserId}
        handleFilter={handleChildClick}
        refetch={refetch}
        handleEmployee={handleEmployeeSelection}
      />
    </div>
  );
};

export default MeetingsTable;
